import { GO_LIVE_DATES } from '../content/dates'
import { PART_C_DOCTORS } from '../preview/doctorData'
import { DoctorEntry } from '../types'

export const MEDICAL_TEAM_PATH = '/equipe-medica'

/** All 16 Part C profiles: owner confirmed consent and medical/legal approval on 2026-10-14.
 * Unknown RQE and other excluded source items remain absent, never inferred.
 */
export const DOCTORS: DoctorEntry[] = PART_C_DOCTORS.map((doctor) => ({
  ...doctor,
  published: true,
  review: { ...doctor.review, ...GO_LIVE_DATES, reviewStatus: 'approved' }
}))
